import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import LogoIso from "src/components/LogoIso";

import Context from "../../../context";

// ----------------------------------------------------------------------

export const Powered = () => {
	const { theme } = useContext(Context);

	return (
		<Stack
			flexDirection={"row"}
			alignItems='center'
			justifyContent={"center"}
			mt={4}
			sx={{ position: "absolute", bottom: 0, right: 0, left: 0 }}
		>
			<Typography
				variant='body1'
				color={theme?.colors.secondaryText}
				fontSize={{ sm: 13, xs: 11 }}
				sx={{ mr: 1 }}
			>
				{"Powered by"}
			</Typography>
			<LogoIso
				width={60}
				sx={{ mt: 0.7, cursor: "pointer" }}
				disabledLink
				onClick={() => window.open("https://www.vumi.io", "_blank")}
			/>
		</Stack>
	);
};

export default Powered;
